{{ totalCost | currency: product.currency }}
<rt-divider variant="dot"></rt-divider>
{{ intervalText }}
